export function notEmpty(value) {
    return value !== null && value !== undefined;
}
export function makeNonEmpty(value) {
    return (value || []).filter(notEmpty);
}
export function groupBy(transactions, getKey, keyComparisonCheck) {
    const group = transactions.reduce((acc, element) => {
        if (element == null) {
            return acc;
        }
        const key = getKey(element);
        if (acc.length === 0) {
            acc.push({
                key: key,
                elements: [element],
            });
            return acc;
        }
        for (let i = 0; i < acc.length; i++) {
            if (keyComparisonCheck(acc[i].key, key) === 0) {
                acc[i].elements.push(element);
                return acc;
            }
            if (keyComparisonCheck(key, acc[i].key) < 0) {
                acc.splice(i, 0, {
                    key: key,
                    elements: [element],
                });
                return acc;
            }
        }
        acc.push({
            key: key,
            elements: [element],
        });
        return acc;
    }, []);
    return group;
}
